import { deleteElement } from './deleteElementThunk';
export default deleteElement;
